export default {
  props: {
    product_id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    "additional_name": {
      type: String,
      required: true
    },
    year: {
      validator: value => value === null || typeof value === "number",
      required: true
    },
    color: {
      type: String,
      default: ""
    },
    picture: {
      type: String,
      default: ""
    },
    quantity: {
      type: Number,
      default: 0
    },
    producer: {
      type: String,
      default: ""
    },
    price: {
      type: Number,
      required: true
    },
    capacity: {
      type: String,
      default: ""
    },
    sold_individually: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    placeholderURL() {
      return require(`../assets/images/wine-placeholder-${this.color ? this.color : "blank"}.png`); // eslint-disable-line import/no-dynamic-require
    },
    thumbURL() {
      return this.picture ? this.picture : this.placeholderURL;
    },
    orderStep() {
      return this.sold_individually ? 1 : 6;
    }
  }
};
